export const getAbsoluteUrl = (): string => {
  const APP_ENV = process.env.NEXT_PUBLIC_APP_ENV;
  switch (APP_ENV) {
    case 'production':
      return 'https://churchonlineplatform.com';
    case 'staging':
      return 'https://online-staging.church';
    case 'review':
      return 'https://online-review.church';
    default:
      return 'http://online-dev.church:7777';
  }
};
